module.exports = "/_next/static/images/1-809ee99b1cb4c8569b12560226ef2f5d.jpg";